import { NoItemsFound } from '~/shared/components/NoItemsFound';
import { getDiagnosesOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { DiagnosesTable } from './DiagnosesTable';
import { PatientDiagnosesFormModal } from './forms/PatientDiagnosesFormModal';

export function PatientDiagnoses({ certificationPeriodId }: { certificationPeriodId: string }) {
	const { data: patientDiagnoses } = useSuspenseQuery(getDiagnosesOptions(certificationPeriodId));

	const diagnoses = patientDiagnoses.current ?? patientDiagnoses.pending;
	if (!diagnoses || !diagnoses.diagnoses || diagnoses.diagnoses.length === 0) {
		return (
			<NoItemsFound
				title="No diagnoses recorded"
				subtitle="Click the button below to add a diagnosis"
				itemCount={0}
				renderModal={closeModal => <PatientDiagnosesFormModal certificationPeriodId={certificationPeriodId} closeModal={closeModal} />}
				renderTable={() => <DiagnosesTable rows={[]} />}
			/>
		);
	}
	return (
		<NoItemsFound
			title="No diagnoses recorded"
			subtitle="Click the button below to add a diagnosis"
			itemCount={diagnoses.diagnoses.length}
			renderModal={closeModal => <PatientDiagnosesFormModal certificationPeriodId={certificationPeriodId} closeModal={closeModal} />}
			renderTable={() => <DiagnosesTable rows={diagnoses.diagnoses} />}
			label={diagnoses.diagnoses.length > 0 ? 'Edit / Reorder' : undefined}
			actionType={diagnoses.diagnoses.length > 0 ? 'edit' : undefined}
			appearance={diagnoses.diagnoses.length > 0 ? 'outline' : undefined}
		/>
	);
}
